import React from 'react';

export const TaxableReceiptsGroup = ({ index, children }) => {
  return (
    <tbody
      style={{
        backgroundColor: index % 2 ? '#ffffff' : '#f0f0f0',
      }}
    >
      {children}
    </tbody>
  );
};
